export const getAuthHostName = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const url = `${protocol}//${hostname}`;
  console.log(process.env.VUE_APP_DEV_URL)
  console.log(url)
  if (url === process.env.VUE_APP_DEV_URL) {
    return process.env.VUE_APP_DEV_AUTH_API_URL;
  }
};

export const getHostName = () => {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  const url = `${protocol}//${hostname}`;
  if (url === process.env.VUE_APP_DEV_URL) {
    /* return process.env.VUE_APP_DEV_LOCAL; */
    return process.env.VUE_APP_BE_URL;
  }
};
